import Card from "../Card"
import SmallHeadingComponent from "../SmallHeadingComponent"
import showcase from "../../resources/medscan_app/mdescan_app.png"
import ProfessionalIcon from "../ProfessionalIcon"

function PokalMedscanApp() {
    return (
        <Card width={"100%"} fill={true}>
            <div className={"flex space-x-4"}>
                <div className={"flex-1 flex flex-col"}>
                    <SmallHeadingComponent>
                        DOOR Studie MedScan App
                    </SmallHeadingComponent>
                    <div className={"mt-4"}>
                        Unterstützt Ärzt:innen beim Scannen von
                        Medikamentenplänen.
                    </div>
                    <div className={"mt-auto"}>
                        <ProfessionalIcon />
                    </div>
                </div>
                <div
                    style={{ marginTop: -50 }}
                    className={"flex-1 max-w-[250px]"}>
                    <img
                        className={"rounded-3xl border-2 shadow rotate-2"}
                        src={showcase}
                    />
                </div>
            </div>
        </Card>
    )
}

export default PokalMedscanApp
